// Datas sem depender de Intl (mais previsível no Android).
import { N_, t } from './i18n';

const p2 = (n: number) => String(n).padStart(2, '0');

export const ymd = (d: Date) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
export const parseYmd = (s: string) => { const [y, m, d] = s.split('-').map(Number); return new Date(y, m - 1, d); };
export const br = (d: Date) => `${p2(d.getDate())}/${p2(d.getMonth() + 1)}/${d.getFullYear()}`;
export const brYmd = (s: string) => br(parseYmd(s));
export const hm = (d: Date) => `${p2(d.getHours())}:${p2(d.getMinutes())}`;

// 0.67 (texto 05 D3, Calendário): a semana começa na segunda (padrão) ou no domingo; hora em 24h (padrão) ou 12h.
let semanaNaSegunda = true;
let hora12 = false;
export function definirCalendario(o: { semanaComeca?: 'seg' | 'dom'; hora12?: boolean }) { semanaNaSegunda = o.semanaComeca !== 'dom'; hora12 = !!o.hora12; }
export const semanaNaSeg = () => semanaNaSegunda;
/** Posição do dia na semana (0 = primeiro dia), conforme "A semana começa na". */
export const posNaSemana = (diaDaSemana: number) => (semanaNaSegunda ? (diaDaSemana + 6) % 7 : diaDaSemana);
/** Hora para mostrar na tela: "14:30" ou, no formato 12h, "2:30 PM". (Os dados guardados continuam em 24h.) */
export function horaTela(hhmm: string | null | undefined): string {
  if (!hhmm || !hora12) return hhmm ?? '';
  const m = /^(\d{1,2}):(\d{2})$/.exec(hhmm.trim());
  if (!m) return hhmm;
  const h = Number(m[1]) % 24;
  return `${h % 12 || 12}:${m[2]} ${h < 12 ? 'AM' : 'PM'}`;
}
export const brDateTime = (iso: string) => { const d = new Date(iso); return `${br(d)} ${horaTela(hm(d))}`; };
export const today = () => ymd(new Date());
export const addDays = (s: string, n: number) => { const d = parseYmd(s); d.setDate(d.getDate() + n); return ymd(d); };

export function addMonths(d: Date, n: number) {
  const r = new Date(d.getFullYear(), d.getMonth() + n, 1);
  const last = new Date(r.getFullYear(), r.getMonth() + 1, 0).getDate();
  r.setDate(Math.min(d.getDate(), last));
  return r;
}

const DIAS = [N_('domingo'), N_('segunda'), N_('terça'), N_('quarta'), N_('quinta'), N_('sexta'), N_('sábado')];
export function labelDia(s: string) {
  const hoje = today();
  if (s === hoje) return t('Hoje');
  if (s === addDays(hoje, 1)) return t('Amanhã');
  if (s === addDays(hoje, -1)) return t('Ontem');
  const d = parseYmd(s);
  return t('{dia}, {d}/{m}', { dia: t(DIAS[d.getDay()]), d: p2(d.getDate()), m: p2(d.getMonth() + 1) });
}

export const uid = () => String(Date.now()) + Math.random().toString(36).slice(2, 6);
export const norm = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

const MESES = [N_('janeiro'), N_('fevereiro'), N_('março'), N_('abril'), N_('maio'), N_('junho'), N_('julho'), N_('agosto'), N_('setembro'), N_('outubro'), N_('novembro'), N_('dezembro')];
const SEMANA = [N_('domingo'), N_('segunda-feira'), N_('terça-feira'), N_('quarta-feira'), N_('quinta-feira'), N_('sexta-feira'), N_('sábado')];
/** Abreviações (cada idioma tem a sua; traduzir com t() ao mostrar). */
export const MES_CURTO = [N_('jan'), N_('fev'), N_('mar'), N_('abr'), N_('mai'), N_('jun'), N_('jul'), N_('ago'), N_('set'), N_('out'), N_('nov'), N_('dez')];
export const SEMANA_CURTA = [N_('dom'), N_('seg'), N_('ter'), N_('qua'), N_('qui'), N_('sex'), N_('sáb')];
export const nomeMes = (m: number) => t(MESES[m]);
const cap = (x: string) => x ? x.charAt(0).toLocaleUpperCase() + x.slice(1) : x;
/** Nome completo do dia da semana, com inicial maiúscula: 0 = Domingo … 6 = Sábado. */
export const nomeDiaSemana = (i: number) => cap(t(SEMANA[((i % 7) + 7) % 7]));
/** Abreviação de três letras, com inicial maiúscula (Seg, Ter...): nunca repete como "S S S". */
export const diaCurto = (i: number) => cap(t(SEMANA_CURTA[((i % 7) + 7) % 7]));
/** "sábado, 3 de outubro de 2026" */
export function longDate(s: string) {
  const d = parseYmd(s);
  return t('{dia}, {d} de {mes} de {a}', { dia: t(SEMANA[d.getDay()]), d: d.getDate(), mes: t(MESES[d.getMonth()]), a: d.getFullYear() });
}
/** "sáb, 3 out" */
export function shortDate(s: string) {
  const d = parseYmd(s);
  return t('{dia}, {d} {mes}', { dia: t(SEMANA_CURTA[d.getDay()]), d: d.getDate(), mes: t(MES_CURTO[d.getMonth()]) });
}
/** Primeiro dia da semana da data: segunda (padrão) ou domingo, conforme Ajustes > Calendário (0.67). */
export const weekStart = (s: string) => addDays(s, -(semanaNaSegunda ? (parseYmd(s).getDay() + 6) % 7 : parseYmd(s).getDay()));
